var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input-base",
    {
      attrs: {
        overlap: _vm.overlap,
        small: _vm.small,
        transparent: _vm.transparent,
        stretched: _vm.stretched,
        slimmer: _vm.slimmer
      }
    },
    [
      !!_vm.inputLabel
        ? _c(
            "label",
            { attrs: { slot: "label", for: _vm.inputName }, slot: "label" },
            [_vm._v("\n\n    " + _vm._s(_vm.inputLabel) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.getInnerStyle + " " + _vm.getExtraStyle,
          attrs: { slot: "input" },
          slot: "input"
        },
        [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected,
                  expression: "selected"
                }
              ],
              class: { dissabled: _vm.dissabled },
              attrs: {
                id: _vm.identification,
                name: _vm.inputName,
                disabled: _vm.dissabled
              },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selected = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  function($event) {
                    return _vm.sendUpdate()
                  }
                ]
              }
            },
            _vm._l(_vm.getFullList, function(opt, i) {
              return _c(
                "option",
                {
                  key: "" + opt.val + i,
                  class: _vm.optionClassName,
                  domProps: { value: opt.val }
                },
                [
                  _vm._v(
                    "\n\n          " + _vm._s(_vm.$t(opt.label)) + "\n      "
                  )
                ]
              )
            }),
            0
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3beb323f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3beb323f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputSelect.vue
// module id = null
// module chunks = 